import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivityTabs, buttonTypes } from 'src/app/shared/constants/commonenums';
import { ButtonValue } from 'src/app/shared/dynamicform/models/common-models';
import { BookingActivity, ClassType, LessonTypes } from 'src/app/shared/Models/SessionBookingDTO';
import { GuestService } from 'src/app/shared/services/guest.service';

@Component({
    selector: 'app-class-info',
    templateUrl: './class-info.component.html',
    styleUrls: ['./class-info.component.scss'],
    standalone: false
})
export class ClassInfoComponent implements OnInit {

  bookButton: ButtonValue;
  backButton: ButtonValue;
  textMaxLegth: number = 500;
  descriptionReadMoreClicked: boolean = false;
  safetyInformationReadMoreClicked: boolean = false;
  classDetail: any = {};
  operatingCurrency: string;
  showAvailableSlotCount = true;
  ClassType = ClassType;
  imageUrl: any;

  constructor(public ts: TranslateService, public gs: GuestService) {
    this.gs.SelectedActivity$.subscribe(data => {
      this.classDetail = data;
      if (this.classDetail) {
        this.setOtherValues();
      }
    });

  }
  setOtherValues() {
    this.imageUrl = `data:image/png;base64,${this.classDetail.ImageData}`
    this.classDetail['bannerImage'] = this.classDetail.ImageData ? this.classDetail.ImageData : '';
    this.classDetail['activityType'] = this.classDetail.ClassType === ClassType.Session ? 'Session' : this.classDetail.ClassType === ClassType.Class ? 'Class' : 'Duration';
    this.showAvailableSlotCount = this.classDetail.LessonType == LessonTypes.GroupLesson;
  }

  ngOnInit(): void {
    this.backButton = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('back'),
      customclass: 'class-detail__cancel-btn',
      disbaledproperity: false
    };
    this.bookButton = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('book'),
      customclass: 'class-detail__confirm-btn',
      disbaledproperity: false
    };
    if(this.gs.OperationCurrency){
      this.operatingCurrency = this.gs.OperationCurrency
    }
  }

  backClick($event) {
    this.gs.SaveBookingObj = {};
    this.gs.TabChange$.next(ActivityTabs.BookingSelection);
  }

  bookClick($event) {
    if (this.gs.bookingSection$.value === BookingActivity.PrivateLesson) {
      this.gs.TabChange$.next(ActivityTabs.PrivateLesson);
    } else {
      this.gs.TabChange$.next(ActivityTabs.ActivitySelection);
    }
  }
}
